import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGtowizardLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 26,
	viewBox: "0 0 34 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.90427 25.4386L13.2425 19.3451L15.9303 17.9092L13.8623 18.3019L16.1389 13.0614L14.7766 9.38562L18.9617 12.6195L19.7779 15.5773L18.2437 15.2337L19.919 16.4242L20.0417 17.0992L22.0913 22.6895L18.3358 21.6524L22.349 23.7388L23.0793 25.5H23.0977L33.0327 0.5C31.1794 0.886598 29.0808 1.19342 26.7673 1.43274L22.8952 12.4354L19.1274 1.88684C18.2683 1.91139 17.403 1.9298 16.5071 1.9298C15.6112 1.9298 14.7644 1.91139 13.9053 1.90525L10.119 12.4477L6.2408 1.42661C3.94575 1.19342 1.85322 0.886598 0 0.5L9.83677 25.2668L9.90427 25.4386Z",
		fill: "currentColor"
	})
});
export default SvgGtowizardLogo;
